import TermsLinks from "./TermsLinks";
const CopyrightDetails = () => {
  const currentYear = new Date().getFullYear();
  return <div className='flex flex-col items-start justify-between gap-6 pt-6 lg:flex-row lg:items-center' data-sentry-component="CopyrightDetails" data-sentry-source-file="CopyrightDetails.tsx">
      <TermsLinks data-sentry-element="TermsLinks" data-sentry-source-file="CopyrightDetails.tsx" />
      <p className='shrink-0 text-sm leading-[2em] text-white'>
        &copy; {currentYear} Signature Stay Collection
      </p>
    </div>;
};
export default CopyrightDetails;